import * as React from 'react'
import styled from 'styled-components'

import { RoleTag, COLORS, styles as S } from '@ulule/owl-kit-components/next'
import * as model from '@owl-nest/models'
import { t } from '@owl-nest/localize'

import { Project } from '../../../../models/project'
import { Fan } from '../../../../models/fan'

type FollowerPropTypes = {
  follower: Fan
  project: Project
}

export function Follower({ follower }: FollowerPropTypes): React.ReactElement<FollowerPropTypes> {
  const label = follower.labels ? model.user.label(follower.labels[0]) : undefined

  return (
    <FollowerContainer>
      {/* Avatar */}
      <Avatar href={follower.is_public ? follower.absolute_url : ''}>
        <S.image.Avatar src={model.user.avatar(follower, '40x40')} type="small" />
      </Avatar>
      <FollowerInfos>
        {/* Name */}
        {follower.is_anonymous ? (
          <S.heading.XXXS>{t('Anonymous backer')}</S.heading.XXXS>
        ) : (
          <S.heading.XXXS as="a" href={follower.is_public ? follower.absolute_url : ''}>
            {model.user.fullName(follower)}
          </S.heading.XXXS>
        )}
        {/* Label */}
        {label && <RoleTag backgroundColor={label.color}>{label.label}</RoleTag>}
      </FollowerInfos>
    </FollowerContainer>
  )
}

const FollowerContainer = styled.div`
  display: flex;
  padding: 7px;
  align-items: center;
  align-content: center;
  background-color: ${COLORS.PRIMARY_GREY_000};
`
const Avatar = styled.a`
  margin-right: 10px;
`
const FollowerInfos = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  align-content: center;

  a {
    text-decoration: none;
  }

  a,
  ${S.heading.XXXS} {
    display: inline-block;
  }

  ${S.heading.XXXS}, ${S.tag.RoleTag} {
    margin-right: 5px;
  }
`
